export const defectReportTypes = {
	PARTSBYWORKORDER: "partsByWorkOrder",
	DEFECTSSUMMARY: "defectsSummary",
	DEFECTSBYSTATUS: "defectsByStatus",
	DEFECTSBYRISK: "defectsByRisk",
	DEFECTSEXCEL: "defectsExcel",
};

export const modelDetailsServiceTabReports = {
	toolsSummary: "toolsSummary",
	toolsByTask: "toolsByTask",
	partsSummary: "partsSummary",
	partsByTask: "partsByTask",
	serviceSheet: "serviceSheet",
	tasksExcel: "tasksExcel",
};
